import "./InventoryDetailsComponent.scss";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../constants";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import HeadingComponent from "../../../shared/components/heading/headingComponent";
import {CommonService} from "../../../shared/services";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../shared/components/tabs/tabsComponent";
import React, {useCallback, useEffect, useState} from "react";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {useNavigate, useParams} from "react-router-dom";
import commonService from "../../../shared/services/common.service";
import StockListComponent from "./stock-list/StockListComponent";
import StockTrackerComponent from "./stock-tracker/StockTrackerComponent";
import ProductDetailsViewEditComponent from "./product-details-view-edit/ProductDetailsViewEditComponent";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {useDispatch} from "react-redux";

interface InventoryDetailsComponentProps {

}
const PRODUCT_DETAILS = 'product_details';
const STOCK_LIST = 'stock_list';
const STOCK_TRACKER = 'stock_tracker';

const InventoryDetailsComponent = (props: InventoryDetailsComponentProps) => {
    const [activeTab, setActiveTab] = useState<"product_details" | "stock_list" | "stock_tracker" >(PRODUCT_DETAILS);
    const params = useParams<{ productId: string | undefined }>();

    const {productId} = params;

    const [productDetails, setProductDetails] = useState<any>(undefined);
    const [isProductDetailsLoading, setIsProductDetailsLoading] = useState<boolean>(false);
    const [isProductDetailsLoaded, setIsProductDetailsLoaded] = useState<boolean>(false);
    const [isProductDetailsLoadingFailed, setIsProductDetailsLoadingFailed] = useState<boolean>(false);
    const [productMode, setProductMode] = useState<"view" | "edit">("view");
    const dispatch = useDispatch();
    const navigate= useNavigate();

    const getProductDetails = useCallback((productId: any) => {
        const payload = {};
        let productDetails: any = {};
        setIsProductDetailsLoading(true);
        setIsProductDetailsLoaded(false);
        setIsProductDetailsLoadingFailed(false);
        CommonService._inventory.getProductDetails(productId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    productDetails = response.data;
                }
                setProductDetails(productDetails);
                setIsProductDetailsLoading(false);
                setIsProductDetailsLoaded(true);
                setIsProductDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setProductDetails(productDetails);
                setIsProductDetailsLoading(false);
                setIsProductDetailsLoaded(false);
                setIsProductDetailsLoadingFailed(true);
            });
    }, []);

    useEffect(() => {
        if (productId) {
            dispatch(setCurrentNavParams("Back", "Inventory", CommonService._routeConfig.InventoryListRoute()));
            dispatch(setSideMenuView('compact'));
        }
    }, [productId, dispatch, navigate]);

    useEffect(() => {
        if (productId) {
            getProductDetails(productId);
        }
    }, [productId, getProductDetails]);

    const handleActiveTabChange = useCallback((value: any) => {
        if (productMode === 'edit') {
            CommonService.openConfirmationDialog(
                {
                    confirmationTitle: 'Please confirm!',
                    confirmationSubTitle: 'Are you sure you want to discard the recent changes?',
                    disableEscKeyClose: false,
                    disableBackdropClose: true,
                    imagePath: `${ImageConfig.ConfirmationImage}`,
                    direction: "up",
                    yes: {
                        text: "Discard",
                        color: "primary"
                    },
                    no: {
                        text: "Cancel",
                        color: "primary"
                    }
                }).then(() => {
                setActiveTab(value);
            }).catch(() => {

            })
        } else {
            setActiveTab(value);
        }
    }, [productMode])

    const handleProductDetailsUpdate = useCallback((updatedProductDetails: any) => {
        setProductDetails(updatedProductDetails);
    }, []);

    return (
        <div className={'product-details-component details-screen screen'}>
            {
                isProductDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile} />
                </div>
            }
            {
                isProductDetailsLoadingFailed && <>
                    <StatusCardComponent title={"Facility details failed to load"}/>
                </>
            }
            {
                isProductDetailsLoaded && <>
                    <div className={'details-module-title'}>Product Details</div>
                    <div className="basic-details-wrapper">
                        <div className="details-screen-header-status-section">
                            <div className="details-screen-header">
                                <HeadingComponent
                                    title={`${CommonService.capitalize(productDetails?.name)}`}
                                />
                            </div>
                        </div>
                        <div className="details-screen-sub-header">
                            <DetailsDataKeyValueComponent
                                title={"Panel Name:"}
                                isHorizontal={true}> {commonService.capitalizeFirstLetterOfEachWord(productDetails?.panelDetails?.name)} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Available Kits:"}
                                isHorizontal={true}> {productDetails?.quantity} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Sold Kits:"}
                                isHorizontal={true}> {productDetails?.quantity} </DetailsDataKeyValueComponent>

                            <DetailsDataKeyValueComponent
                                title={"Last Updated On:"}
                                isHorizontal={true}>
                                <>
                                    {commonService.formatDate(productDetails?.updatedAt)}
                                    &nbsp;|&nbsp;
                                    {commonService.formatTime(productDetails?.updatedAt)}
                                </>
                            </DetailsDataKeyValueComponent>
                        </div>
                    </div>
                    <div className="clear-fix"/>
                    <div className="details-screen-body">
                        <TabsWrapperComponent>
                            <TabsComponent
                                value={activeTab}
                                allowScrollButtonsMobile={false}
                                onUpdate={(e: any, v: any) => {
                                    handleActiveTabChange(v);
                                }}
                                variant={"fullWidth"}
                            >
                                <TabComponent label="PRODUCT DETAILS" value={PRODUCT_DETAILS}/>
                                <TabComponent label="STOCK LIST" value={STOCK_LIST}/>
                                {/*<TabComponent label="STOCK TRACKER" value={STOCK_TRACKER}/>*/}
                            </TabsComponent>
                            <TabContentComponent selectedTab={activeTab} value={PRODUCT_DETAILS}>
                                        <ProductDetailsViewEditComponent productDetails={productDetails}
                                                                         onUpdateProductDetails={handleProductDetailsUpdate}
                                                                         onModeChange={(mode:any)=>{setProductMode(mode)}}
                                                                         canEdit={true}/>
                            </TabContentComponent>
                            <TabContentComponent selectedTab={activeTab} value={STOCK_LIST}>
                                <StockListComponent
                                    onModeChange={(mode:any)=>{setProductMode(mode)}}
                                    productId={productId}
                                />
                            </TabContentComponent>
                            <TabContentComponent selectedTab={activeTab} value={STOCK_TRACKER}>
                                <StockTrackerComponent/>
                            </TabContentComponent>
                        </TabsWrapperComponent>
                    </div>
                </>
            }
        </div>

    );

};

export default InventoryDetailsComponent;
